<template>
  <div>
    <!-- 搜索区 -->
    <!-- <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" /> -->

    <!--客户搜索筛选框-->
    <!-- <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" /> -->
    <!-- <van-tabs v-model="active" @change="handleClick" :ellipsis="false" class="tab">
      <van-tab title="新建" :badge="custCount.xjCount != 0?custCount.xjCount:''"></van-tab>
      <van-tab title="商机" :badge="custCount.sjCount != 0?custCount.sjCount:''"></van-tab>
      <van-tab title="签约中" :badge="custCount.qyzCount != 0?custCount.qyzCount:''"></van-tab>
      <van-tab title="执行中" :badge="custCount.zzzxCount != 0?custCount.zzzxCount:''"></van-tab>
      <van-tab title="已执行" :badge="custCount.yzxCount != 0?custCount.yzxCount:''"></van-tab>
    </van-tabs> -->
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
      因权限问题，部分数据不方便显示
    </van-notice-bar>
    <van-search v-model="queryParams.custName" placeholder="请输入客户名称搜索" @search="queryCustList" />
    <empty-component v-if="isEmpty" />
    <van-list v-model="loading" :finished="noOrderFinished"  finished-text="没有更多了" v-hasPermi="['scrm:customer:list']" @load="handleNo" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <list-item @todetail="toCustBlueDetails" :listData="list"  :dictOptions="options"/>
    </van-list>
  </div>
</template>

<script>
import { listCust, getMyCustomerCount } from '@/api/scrm/mycust'
import { areaList } from '@vant/area-data'
import ListItem from '@/views/scrm/component/custsale/ListItem.vue'
import { getDicts } from '@/api/system/dict/data'
// import SearchComponent from '@/components/common/Search'
import TotalComponent from '@/components/common/Total'
// import SearchPop from '../component/SearchPop.vue'
import EmptyComponent from '@/components/common/Empty'
import { NoticeBar } from 'vant'
export default {
  name: 'custList',
  components: {
    ListItem,
    EmptyComponent,
    //  SearchComponent, SearchPop
    TotalComponent,
    [NoticeBar.name]: NoticeBar
  },
  data() {
    return {
      isEmpty: false,
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      loading: false,
      finished: false,
      noOrderFinished: false,
      active: 0,
      custCount: {},
      list: [],
      total: 0,
      show: false,
      type: 'add',
      showFilterPop: false,
      searchValue: '',
      custList: [],
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || []
      },
      form: {
        custType: null,
        custName: null
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        isWaters: 1,
        custName: '',
        // custStatus: '1',
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  created() {
    if (this.$route.query.queryParams) {
      this.queryParams = { ...this.queryParams, ...JSON.parse(this.$route.query.queryParams) }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = 'scrm统计列表'
      await this.handleNo()
      // await this.getCustCount()
    },
    QueryReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.isEmpty = false
      this.QueryReset()
      this.queryParams.custName = this.searchValue = data
      this.queryCustList()
      this.getCustCount()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      this.isEmpty = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.getCustCount()
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleNo()
      // this.handleList();
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },

    toCustBlueDetails(item) {
      this.$router.push(`/scrm/custManage/detail/${item.custId}`)
    },
    showPicker(type) {
      this.picker.formKey = type
      if (this.options.custTypeOptions.length) {
        if (type === 'custType') {
          this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
        }
      } else {
        getDicts('crm_mycust_type').then(res => {
          this.options.custTypeOptions = res.data
          if (type === 'custType') {
            this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
          }
        })
      }
      this.picker.visible = true
    },
    addCust() {
      this.show = true
    },
    async handleList() {
      this.loading = true
      // this.queryParams.custName = this.$route.query.custName || ''
      const res = await listCust(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
        this.showFilterPop = false
      }
    },
    handleClick(val) {
      this.queryParams.custStatus = val + 1
      this.queryCustList()
    },
    async handleNo() {
      this.loading = true
      const res = await listCust(this.queryParams)

      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.loading = false
        this.noOrderFinished = this.list.length >= res.total
        this.showFilterPop = false
      }
    },
    getCustCount() {
      // const query = this.queryParams
      // query.custStatus = null
      getMyCustomerCount({ ...this.queryParams, custStatus: null }).then(res => {
        if (res.code === 200) {
          if (!res.data) {
            this.custCount = {
              xjCount: 0,
              sjCount: 0,
              qyzCount: 0,
              zzzxCount: 0,
              yzxCount: 0
            }
          } else {
            this.custCount = res.data
          }
        }
      })
    },
    onLoad() {
      this.handleNo()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.tab{
  padding-top: 100px;
  margin-bottom: -100px;
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.van-list{
  padding-top: 0;
}
</style>
